import React from 'react'
import { Currencies } from '@orbital/games-frontend-library'
import { CashoutAt } from "./styled"

export default function CashoutAtText({ cashoutAt, currency }: any) {
    return (
        <CashoutAt>AUTO CASHOUT AT {Currencies[currency]}{cashoutAt}</CashoutAt>
    )
}
